import {ChangePasswordUserBody} from './userTypes';
import {History} from 'history';
import fetch from 'node-fetch';
import {UserChangePasswordApi, ServicesErrors} from '../../constants';
import {handleResponse, handleCommonErrorResponse, determineErrorLevelForSentry} from '../../utils';
import * as Sentry from '@sentry/browser';

export function changePassword(userData: ChangePasswordUserBody, history: History): Promise<string> {
  const requestOptions = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(userData)
  };

  return fetch(UserChangePasswordApi, requestOptions)
    .then(handleResponse)
    .catch(error => {
      const errorLevel = determineErrorLevelForSentry(error);

      Sentry.configureScope((scope) => {
        scope.setLevel(errorLevel);
      })

      Sentry.addBreadcrumb({
        category: 'auth',
        message: 'Endpoint ' + UserChangePasswordApi,
        data: {
          error: error,
        },
        level: errorLevel,
      });
      Sentry.captureMessage(`${ServicesErrors.user.changePasswordFailed} with ${error.message}`, errorLevel);
      return handleCommonErrorResponse(error, history)
    });
}
